import { render, staticRenderFns } from "./CaseManage.vue?vue&type=template&id=b677edda&scoped=true&"
import script from "./CaseManage.vue?vue&type=script&lang=js&"
export * from "./CaseManage.vue?vue&type=script&lang=js&"
import style0 from "./CaseManage.vue?vue&type=style&index=0&id=b677edda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b677edda",
  null
  
)

export default component.exports